import { omrehBaseClient } from "./client";

const GetById = (key) => {
  return omrehBaseClient
    .get("/GuestPassenger/GetById", {
      params: {
        'key': key
      }
    });
}

const guestPassengerApi = {
   GetById
}

export default guestPassengerApi